<template>
  <div>
    <b-modal id="checkin-info-modal" ref="checkin-info-modal-ref" hide-footer hide-header title="Checkin Information">
      <div class="vtd-modal-content">
        <div class="vtd-modal-header">
          <h5 class="vtd-modal-title">
            Check-In Information for Booking:
            <strong style="text-transform: uppercase">{{
              bookingNumber
              }}</strong>
          </h5>
          <button type="button" class="close" aria-label="Close" @click="closeModal">
            <span aria-hidden="true"><i class="material-icons">&#xE5CD;</i></span>
          </button>
        </div>

        <div class="vtd-modal-body">
          <p class="checkin-item-text">
            To access your booking on the airline's website, manage preferences and, when applicable, check in online,
            you will require your airline reference (below). Occasionally, airlines will require you to access your
            booking using your E-Ticket number – once your ticket has been issued, these can be found on ViewTrail under
            Trip Hub > Flights > E-Tickets. <br /><br />We strongly recommend you install the airlines app to your
            device as generally there is additional functionality and options available, often including real time
            notifications relating to your journey.
          </p>
          <div v-for="(item, index) in flights" :key="`checkin-info-${index}`">
            <div v-if="item.checkininfo && item.checkininfo.link && FIL === 'M'" class="checkin-item">
              <p class="checkin-item-text">
                <strong>{{ item.checkininfo.name }}</strong>
              </p>
              <p>Online check in opens {{ (Number(item.checkininfo.time) % 24 === 0) && Number(item.checkininfo.time) >
                96 ? `${item.checkininfo.time / 24} days` : `${item.checkininfo.time} hours` }} before departure</p>
              <div class="checkin-item-ref">
                <p class="checkin-item-ref-title">
                  Airline Ref
                </p>
                <p class="checkin-item-ref-number">
                  {{ item.vendorloc }}
                </p>
              </div>
              <a :href="item.checkininfo.link" target="_blank" class="checkin-btn">Manage Booking</a>
            </div>
          </div>
        </div>
        <div class="btn-wrap">
          <div class="vtd-modal-footer vtd-bg-faded vtd-flex-column">
            <small>This information was generated at:
              <strong class="return-date">{{ returnDate }}</strong></small>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import dayjs from '@/lib/dayjs';
import { mapState } from "vuex";

export default {
  data() {
    return {
      flights: null,
      FIL: null
    };
  },
  computed: {
    // Get a handle on booking store
    ...mapState(["booking"]),

    // We need the booking number from the booking store
    bookingNumber() {
      return this.$store.getters["booking/getBookingNumber"];
    },
    returnDate() {
      return dayjs().format("DD-MMM-YYYY HH:mm");
    },
  },
  mounted() {
    this.flights = this.getFlights()
    this.FIL = this.booking.booking.booking_information.fil
  },
  methods: {
    // This method is called externally from the drop down menu to Show Visa
    async showModal(menuPayload) {
      // This is the Vue Bootstrap Show method
      this.$refs["checkin-info-modal-ref"].show();
    },
    getFlights() {
      const flights = this.booking.booking.itinerary_transformed.items.map(item => item.data.filter((item2 => item2.jsontype === 'flight'))).flat()
      const filteredFlights = []
      const flightRefs = []
      for (const flight of flights) {
        if (!flightRefs.includes(flight.vendorloc)) {
          filteredFlights.push(flight)
          flightRefs.push(flight.vendorloc)
        }
      }

      return filteredFlights
    },
    openLink(link) {

    },
    closeModal() {
      this.$refs["checkin-info-modal-ref"].hide();
    },
  },
};
</script>

<style scoped>
.checkin-btn {
  display: flex;
  width: 100%;
  border: none;
  font-weight: 100;
  background-color: #629dd3;
  color: #fff;
  padding: 10px;
  text-align: center;
  justify-content: center;
  cursor: pointer;
}

.checkin-btn:hover {
  text-decoration: none;
}

.checkin-item {
  margin: 20px 0;
}

.checkin-item-text {
  text-align: left;
}

.checkin-item-ref {
  display: flex;
}

.checkin-item-ref-title {
  margin-right: 5px;
  font-size: 20px;
}

.checkin-item-ref-number {
  color: #76c95f;
  font-size: 20px;
}
</style>